import { render } from "./LoadingSpin.vue?vue&type=template&id=aa9a40f8&scoped=true&ts=true"
import script from "./LoadingSpin.vue?vue&type=script&lang=ts"
export * from "./LoadingSpin.vue?vue&type=script&lang=ts"

import "./LoadingSpin.vue?vue&type=style&index=0&id=aa9a40f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa9a40f8"]])

export default __exports__